import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ConnectivityEmergencyStopIcon = ({ color, ...rest }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorError;

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.49087 9.02849C5.93425 10.9262 5 13.354 5 16C5 18.646 5.93425 21.0738 7.49087 22.9715L26.7907 18.1466C26.928 17.4523 27 16.7346 27 16C27 15.2654 26.928 14.5477 26.7907 13.8534L7.49087 9.02849ZM9.16043 7.38433L26.0922 11.6173C24.3988 7.72306 20.5174 5 16 5C13.4149 5 11.0381 5.89172 9.16043 7.38433ZM16 27C13.4149 27 11.0381 26.1083 9.16043 24.6157L26.0922 20.3827C24.3988 24.2769 20.5174 27 16 27ZM3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16Z"
        fill={currentColor}
      />
      <path
        opacity="0.2"
        d="M26.1018 11.6173L9.16998 7.38433C11.0477 5.89172 13.4245 5 16.0096 5C20.5269 5 24.4083 7.72306 26.1018 11.6173Z"
        fill={currentColor}
      />
      <path
        opacity="0.2"
        d="M9.16992 24.613C11.0476 26.1056 13.4244 26.9973 16.0095 26.9973C20.5269 26.9973 24.4083 24.2742 26.1017 20.38L9.16992 24.613Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default ConnectivityEmergencyStopIcon;
